<div *ngIf="input.invalid" class="invalid-feedback">
  <div *ngIf="input.errors['required']"><span>Verplicht</span></div>
  <div *ngIf="input.errors['email']"><span>Ongeldig</span></div>
  <div *ngIf="input.errors['minlength']"><span>Te kort</span></div>
  <div *ngIf="input.errors['pattern']"><span>Ongeldig</span></div>
  <div *ngIf="input.errors['loginPhraseInvalid']"><span>Ongeldige inlogcode</span></div>
  <div *ngIf="input.errors['owlDateTimeParse']"><span>Ongeldige datum</span></div>
  <div *ngIf="input.errors['owlDateTimeMin']"><span>Kies een latere datum</span></div>
  <div *ngIf="input.errors['owlDateTimeMax']"><span>Kies een eerdere datum</span></div>
</div>
